import { Link } from "react-router-dom";
import { Mail, Phone, Facebook, Instagram, Linkedin } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

/**
 * Landing V2 — Minimal footer.
 * One quiet line. Contact, legal, social. No branding noise.
 */
export function MinimalFooter() {
  const { t } = useLanguage();

  return (
    <footer className="mt-8 sm:mt-12 border-t border-border/40 px-6 py-6 sm:py-8">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 sm:gap-6 text-xs text-muted-foreground">
        {/* Left: contact */}
        <div className="flex items-center gap-4">
          <a
            href="mailto:info@orderflow.ge"
            className="flex items-center gap-1.5 hover:text-foreground transition-colors"
          >
            <Mail className="h-3.5 w-3.5" />
            <span>info@orderflow.ge</span>
          </a>
          <a
            href="tel:+995505051685"
            className="hidden sm:flex items-center gap-1.5 hover:text-foreground transition-colors"
          >
            <Phone className="h-3.5 w-3.5" />
            <span>+995 505 051 685</span>
          </a>
        </div>

        {/* Center: legal */}
        <div className="flex items-center gap-4">
          <Link to="/privacy-policy" className="hover:text-foreground transition-colors">
            {t("register.privacyPolicy")}
          </Link>
          <Link to="/terms-of-service" className="hover:text-foreground transition-colors">
            {t("register.termsOfService")}
          </Link>
          <span>© 2025 OrderFlow</span>
        </div>

        {/* Right: social */}
        <div className="flex items-center gap-3">
          <a
            href="https://www.facebook.com/profile.php?id=61583496086690"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            className="hover:text-foreground transition-colors"
          >
            <Facebook className="h-4 w-4" />
          </a>
          <a
            href="https://www.instagram.com/orderflow.ge"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            className="hover:text-foreground transition-colors"
          >
            <Instagram className="h-4 w-4" />
          </a>
          <a
            href="https://www.linkedin.com/company/orderflowge"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            className="hover:text-foreground transition-colors"
          >
            <Linkedin className="h-4 w-4" />
          </a>
        </div>
      </div>
    </footer>
  );
}
